import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'checkout-opening-hour-line',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './opening-hour-line.component.html',
})
export class OpeningHourLineComponent {
    @Input() public dayName: string;
    @Input() public dayOpeningHours: string;
    @Input() public isBold: boolean = false;
}
